// A SIRET (14 digits) is composed of the 9-digit SIREN followed by a 5-digit NIC,
// so the SIREN is the first 9 digits of the SIRET.
const SIREN_LENGTH = 9

export const getSirenFromSiret = (siret: string | undefined | null): string | undefined => {
  if (!siret || siret.length < SIREN_LENGTH) {
    return undefined
  }

  return siret.slice(0, SIREN_LENGTH)
}
